import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { tokenValidation } from "../../../redux/actions/userAction";

import axios from "axios";

import "./playlist.css";

const Playlist = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const userState = useSelector(state => state.user); // { isLoading, validToken, id, username, email, err }

	
	const [playlistVisible, setPlaylistVisible] = useState(false); // PV: "random", "customize"
	const [isPlaylistBtnClicked, setPlaylistBtnClicked] = useState(false); // PV: "random", "customize"

	const [link, setLink] = useState(""); // PV: "random", "customize"
	const [quote, setQuote] = useState(""); // PV: "random", "customize"
	const [track, setTrack] = useState({ link: "", quote: "", date: "" }); // PV: userInput
	const [addTrackVisible, setAddTrackVisible] = useState(false); // PV: userInput
	

	useEffect(() => {
		getTrack();
	}, [window.location.origin]);


	useEffect(() => {
		if (!userState.isLoading && isPlaylistBtnClicked) {
			setPlaylistBtnClicked(false)
			if (userState.validToken) {
				setPlaylistVisible(true)
			} else history.push("/login");
		}
	}, [userState]);

	function getTrack() {
		const currentDate = new Date().toLocaleDateString().split("/");
		axios
			.get(`/api/playlist/music/${currentDate[2]}-${currentDate[0]}-${currentDate[1]}`)
			.then(res => {
				setLink(res.data.track.link);
				setQuote(res.data.track.quote);
			})
			.catch(err => {
				console.log("error not found");
			});
	}

	function addTrack() {
		axios
			.post("api/playlist/music", track)
			.then(() => {
				console.log("Track successfully added");
				setTrack({ link: "", quote: "", date: "" });
			})
			.catch(() => console.log("add Track failed"));
	}

	function handleTrackChange(e) {
		setTrack({ ...track, [e.target.name]: e.target.value });
		// This is a buggy file
		// Tial heroku/master
	}
	return (
		<div className="playlist">
			<input 
				type="button" 
				value="PLAYLIST" 
				className="playlist-btn" 
				onClick={() => {
					dispatch(tokenValidation()); // validating the token
					setPlaylistBtnClicked(true);
				}}
			/>
			{/* <div className="playlist-btn" onClick={() => {dispatch(tokenValidation()); // validating the token */}
			{/* setPlaylistBtnClicked(true)}} /> */}
			<div className={playlistVisible ? "playlist-container-visible" : "playlist-container-hidden"}>
				<div className="bg-clicker" onClick={() => setPlaylistVisible(false)} />
				<iframe
					className="music-video"
					
					src={link}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>
				<span className="quote">{quote.replaceAll("<br/>", "\n")}</span>

				<div className="add-track-btn" onClick={() => setAddTrackVisible(true)} />
				
				<div className={addTrackVisible ? "add-track-visible" : "add-track-hidden"}>
					<div className="bg-clicker" onClick={() => setAddTrackVisible(false)} />
					<form
						className="add-track-container"
						onSubmit={e => {
							e.preventDefault();
							addTrack();
						}}
					>
						<input type="text" name="link" placeholder="link" required value={track.link} onChange={e => handleTrackChange(e)} />
						<input
							type="text"
							name="quote"
							placeholder="quote"
							required
							value={track.quote}
							onChange={e => handleTrackChange(e)}
						/>
						<input type="date" name="date" placeholder="date" required value={track.date} onChange={e => handleTrackChange(e)} />
						<input type="submit" value="Add Track" />
					</form>
				</div>
			</div>
		</div>
	);
};

export default Playlist;
